import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { SERVICE_INTRO_SAMPLE } from "../consts";
import { ServiceSceneProps } from "../types";

const SERVICE_SAMPLE_COSTS = [
  { name: "Rad", amount: "180,00 €" },
  { name: "Dijelovi", amount: "240,00 €" },
];

/** Korak "Dokumentacija": priloženi dokumenti naloga, trošak servisa i sve na istom nalogu. */
const ServiceDocumentsScene: React.FC<ServiceSceneProps> = ({ formValues }) => {
  const uploadedNames = formValues.documentUploads.map((upload) => upload.originalFileName);
  const documents = uploadedNames.length > 0 ? uploadedNames : SERVICE_INTRO_SAMPLE.documents;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Dokumentacija naloga</div>
          <div className="text-sm font-bold text-slate-800 truncate">{formValues.name || SERVICE_INTRO_SAMPLE.name}</div>
          <div className="mt-3 space-y-2">
            {documents.slice(0, 4).map((document) => (
              <div key={document} className="flex items-center gap-2 rounded-md bg-slate-50 px-2 py-2">
                <span className="flex items-center justify-center w-6 h-7 rounded-sm bg-rose-50 text-[0.5rem] font-bold text-rose-500 flex-shrink-0">
                  PDF
                </span>
                <span className="flex-1 text-[0.7rem] font-medium text-slate-700 truncate">{document}</span>
                <CheckIcon />
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Trošak servisa</div>
          <div className="mt-3 space-y-1.5">
            {SERVICE_SAMPLE_COSTS.map((cost) => (
              <div key={cost.name} className="flex justify-between text-[0.7rem]">
                <span className="text-slate-500">{cost.name}</span>
                <span className="font-semibold text-slate-700">{cost.amount}</span>
              </div>
            ))}
          </div>
          <div className="mt-3 flex items-end justify-between border-t border-slate-100 pt-2">
            <span className="text-[0.65rem] text-slate-400">Ukupno</span>
            <span className="text-base font-bold text-slate-800">420,00 €</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Sve na istom nalogu"
          subtitle="Dokumenti, troškovi i štete"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(ServiceDocumentsScene);
